import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";

export default function AdminCategories() {
  const [items, setItems] = useState([]);
  const [name, setName] = useState("");
  const [color, setColor] = useState("#1A3C5A");
  const load = useCallback(async () => setItems((await api.get("/admin/categories")).data), []);
  useEffect(() => { load(); }, [load]);

  const add = async () => {
    if (!name.trim()) return;
    await api.post("/admin/categories", { name: name.trim(), color, active: true, order: items.length });
    setName(""); toast.success("Added"); load();
  };
  const upd = async (c, patch) => {
    await api.patch(`/admin/categories/${c.id}`, { name: c.name, color: c.color, active: c.active, order: c.order, ...patch });
    load();
  };
  const del = async (id) => { if (!confirm("Delete category?")) return; await api.delete(`/admin/categories/${id}`); load(); };

  return (
    <div>
      <h1 className="font-display text-2xl font-bold tracking-tight text-[#1A3C5A] mb-4">Categories</h1>
      <div className="flex gap-2 mb-4 max-w-md items-center">
        <Input value={name} onChange={(e)=>setName(e.target.value)} placeholder="New category…" className="bg-white" data-testid="new-cat-name"/>
        <input type="color" value={color} onChange={(e)=>setColor(e.target.value)} className="h-9 w-12 border border-border rounded" data-testid="new-cat-color"/>
        <Button onClick={add} className="bg-[#1A3C5A] text-white hover:bg-[#12293e]" data-testid="add-cat-btn"><Plus size={14} className="mr-1"/>Add</Button>
      </div>
      <div className="bg-white border border-border rounded-md overflow-hidden max-w-2xl">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-xs uppercase tracking-widest text-slate-500 font-display">
            <tr><th className="py-2 px-2 text-left">Name</th><th className="py-2 px-2">Color</th><th className="py-2 px-2">Active</th><th className="py-2 px-2 w-16"></th></tr>
          </thead>
          <tbody>
            {items.map(c => (
              <tr key={c.id} className="border-t border-border" data-testid={`cat-row-${c.id}`}>
                <td className="py-1.5 px-2">
                  <div className="flex items-center gap-2">
                    <span className="inline-block w-2.5 h-2.5 rounded-full" style={{backgroundColor: c.color}}/>
                    <Input defaultValue={c.name} onBlur={(e)=> e.target.value !== c.name && upd(c, { name: e.target.value })}
                           className="h-8 border-transparent hover:border-border focus:border-[#1A3C5A]"/>
                  </div>
                </td>
                <td className="py-1.5 px-2 text-center">
                  <input type="color" defaultValue={c.color} onBlur={(e)=>e.target.value !== c.color && upd(c, { color: e.target.value })}
                         className="h-7 w-10 border border-border rounded"/>
                </td>
                <td className="py-1.5 px-2 text-center">
                  <Switch checked={c.active} onCheckedChange={(v)=>upd(c, { active: v })} />
                </td>
                <td className="py-1.5 px-2 text-right">
                  <Button size="sm" variant="ghost" onClick={()=>del(c.id)} className="text-red-600"><Trash2 size={13}/></Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
